import * as Yup from 'yup';


export const ValidationSchema = Yup.object({
    username: Yup.string().email('Please enter a valid email').required('Email required'),
    password: Yup.string().required('Password required'),
})


export const InitialData = {
    username: '',
    password: '',
    grant_type: 'password',
    // rememberMe: true
}

export const ValidationSchemaReset = Yup.object({
    email: Yup.string().email('Please enter a valid email').required('Email required'),
})

export const ValidationSchemaChangePassword = Yup.object({
    password: Yup.string().required('Password required'),
    matchingPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords do not match').required('Confirm password required'),
})